import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const PlusIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <line
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={16}
        y1={2}
        x2={16}
        y2={30}
        strokeLinejoin="miter"
      />
      <line
        fill="none"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        x1={30}
        y1={16}
        x2={2}
        y2={16}
        strokeLinejoin="miter"
      />
    </svg>
  );
};
